import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';

/**
 * Barra "Tem uma dúvida? Pergunte ao Cog" no topo da Home (card 3786). Só a caixa de pergunta: ao
 * enviar, emite o texto e a Home abre o chat do Cog (`app-floating-ai-button` →
 * `app-ai-chat-sidebar-wrapper`) com a pergunta como `autoInstruction`.
 *
 * Usa `<input>` nativo de propósito: o Design System não tem wrapper para caixa de prompt em pílula
 * com botão de envio (o `app-search` filtra lista enquanto digita, não envia pergunta).
 */
@Component({
  selector: 'app-home-cog-search',
  standalone: true,
  templateUrl: './home-cog-search.component.html',
  styleUrls: ['./home-cog-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeCogSearchComponent {
  readonly ask = output<string>();

  readonly question = signal('');

  onInput(event: Event): void {
    this.question.set((event.target as HTMLInputElement).value);
  }

  submit(event: Event): void {
    event.preventDefault();
    const question = this.question().trim();
    if (!question) {
      return;
    }

    this.ask.emit(question);
    this.question.set('');
  }
}
